import { DefaultFilters } from '@backstage/plugin-catalog-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogPlugin, {
  CatalogIndexPage,
  CatalogTableColumnsFunc,
} from '@backstage/plugin-catalog/alpha';
import { CatalogTable } from '@backstage/plugin-catalog';
import { UserAccountStatusPicker } from '../users/UserAccountStatusPicker.tsx';
import { EntitySystemPicker } from './EntitySystemPicker.tsx';
import { EntityMaintainedPicker } from './EntityMaintainedPicker.tsx';
import { userStatusColumn } from '../users';

const columnsFunc: CatalogTableColumnsFunc = entityListContext => {
  const kind =
    entityListContext.filters.kind?.value?.toLocaleLowerCase('en-US') ?? '';
  const defaultColumns = CatalogTable.defaultColumnsFunc(entityListContext);

  const columns = defaultColumns.map(col =>
    col.field === 'resolved.entityRef'
      ? { ...col, defaultSort: 'asc' as const }
      : col,
  );

  if (kind === 'user') {
    return [...columns, userStatusColumn];
  }
  return columns;
};

const catalogPageOverride = catalogPlugin
  .getExtension('page:catalog')
  .override({
      factory(originalFactory) {
      return originalFactory({
        params: {
          loader: async () => (
            <CatalogIndexPage
              columns={columnsFunc}
              filters={
                <>
                  <DefaultFilters />
                  <EntitySystemPicker />
                  <EntityMaintainedPicker />
                  <UserAccountStatusPicker />
                </>
              }
            />
          ),
        },
      });
    },
  });

export const catalogColumnsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogPageOverride],
});
